// Port of ios/Sources/ViewModels/DirectChannelVisibility.swift.
//
// Closing a direct or group message (shared/API.md §29) — the desktop's "Close Direct Message"
// and "Close Group Message". It is not leaving and it is not archiving: nothing is deleted,
// nobody is removed, and the next message the other person sends brings the conversation
// straight back into the sidebar.

/** Preference categories on the wire. Not display strings — never localise them. */
export const directCategory = 'direct_channel_show';
export const groupCategory = 'group_channel_show';

/** One preference row: which list it belongs to and what it names. */
export interface Preference {
  category: string;
  name: string;
}

export function canClose(channelType: string): boolean {
  return channelType === 'D' || channelType === 'G';
}

/**
 * THE TRAP: a direct message is keyed by the OTHER PERSON's user id, not by the channel id — the
 * server tracks the visibility against the teammate. A group message has no single teammate and
 * is keyed by the channel. Getting this backwards writes a preference the server accepts, stores,
 * and never reads. Returns null when the row cannot be named — the action must then not be
 * offered at all.
 */
export function preferenceFor(channelType: string, channelId: string, otherUserId: string | null | undefined): Preference | null {
  switch (channelType) {
    case 'D':
      if (!otherUserId || otherUserId.trim() === '') return null;
      return { category: directCategory, name: otherUserId };
    case 'G':
      return { category: groupCategory, name: channelId };
    default:
      return null;
  }
}

/** Namespace form, for `DirectChannelVisibility.preferenceFor(...)` call sites. */
export const DirectChannelVisibility = { directCategory, groupCategory, canClose, preferenceFor } as const;
